"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getChevronPosition = exports.defaultTitleRenderer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = _interopRequireDefault(require("react"));
var _text = require("../text");
var _utils = require("../utils");
var _constants = require("./constants");
var _interfaces = require("./interfaces");
var _react2 = require("@emotion/react");
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; } // Default chevron position to trailing if card layout is used. Allow overrides.
const getChevronPosition = _ref => {
  let {
    chevronPositionProp,
    isCardLayout
  } = _ref;
  if (isCardLayout && chevronPositionProp === undefined) {
    return _interfaces.ExpanderChevronPosition.Trailing;
  }
  if (chevronPositionProp !== undefined) {
    return chevronPositionProp;
  }
  return _interfaces.ExpanderChevronPosition.Leading;
};
exports.getChevronPosition = getChevronPosition;
const getTitleComponent = headingLevel => {
  switch (headingLevel) {
    case 1:
      return _text.H1;
    case 2:
      return _text.H2;
    case 3:
      return _text.H3;
    case 4:
      return _text.H4;
    case 5:
      return _text.H5;
    case 6:
      return _text.H6;
    default:
      return _text.Text;
  }
};
const defaultTitleRenderer = _ref2 => {
  let {
    hasBoldTitle,
    headingLevel,
    size,
    titleText,
    toggle,
    ...forwardedProps
  } = _ref2;
  const Title = /*#__PURE__*/(0, _base.default)(getTitleComponent(headingLevel), process.env.NODE_ENV === "production" ? {
    target: "e1umn4qz0"
  } : {
    target: "e1umn4qz0",
    label: "Title"
  })(process.env.NODE_ENV === "production" ? {
    name: "e0dnmk",
    styles: "cursor:pointer"
  } : {
    name: "e0dnmk",
    styles: "cursor:pointer",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  });
  const isHeading = hasBoldTitle || headingLevel;
  const isSmall = size === _interfaces.ExpanderSize.Small;
  let titleVariant;
  if (isHeading) {
    titleVariant = isSmall ? _text.TextVariant.HeadingSM : _text.TextVariant.HeadingMD;
  } else {
    titleVariant = isSmall ? _text.TextVariant.BodyMDInteractive : _text.TextVariant.BodyLGInteractive;
  }
  return (0, _react2.jsx)(Title, (0, _extends2.default)({}, (0, _utils.pickDataProps)(forwardedProps), {
    "aria-hidden": true,
    color: _constants.EXPANDER_HEADER_COLOR,
    onClick: toggle,
    variant: titleVariant
  }), titleText);
};
exports.defaultTitleRenderer = defaultTitleRenderer;